<template>
<div id="apptable" v-cloak>

    <b-card :header="'Opzioni sondaggio ' + getDescTipo(this.$route.params.tipo).toLowerCase() + ' #' + this.$route.params.id + ' - ' + this.domandasondaggioscheda" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
        <div class="text-left">

            <div class="my-1 row">
                <div class="col-md-3">
                    <b-form-input v-model="filter" placeholder="Cerca..." />
                </div>
                <div class="col-md-4">
                    <b-button variant="warning" v-on:click="risultatitot()">
                        Risultati totali
                    </b-button>
                </div>
                <div class="col-md-5 text-right">
                    <b-button size="md" variant="outline-primary" @click.stop="insert()">
                        Inserisci
                    </b-button>
                </div>
            </div>

            <!-- Main table element -->
            <b-table responsive v-show="showtable" id="main-table" striped hover show-empty :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @filtered="onFiltered" empty-text="Non sono stati trovati record da visualizzare" empty-filtered-text="Non sono stati trovati record corrispondenti alla tua richiesta">
                <template slot="id" scope="row">{{row.value}}</template>
                        <template slot="id" scope="row">{{row.value}}</template>
                        <template slot="risposta" scope="row">{{row.value}}</template>
                        <template slot="percentualesondaggiorisposte" scope="row">{{row.value}}</template>
                        <template slot="numerosondaggiorisposteVis" scope="row">{{row.value}}</template>
                        <template slot="modifica" scope="row">
                            <!-- We use click.stop here to prevent a 'row-clicked' event from also happening -->
                            <b-btn style="margin:0px 0px 1px 2px;" variant="warning" size="sm" @click.stop="del(row.item,row.index,$event.target)">Elimina</b-btn>
                            <b-btn style="margin:0px 0px 1px 2px;" size="sm" @click.stop="details(row.item,row.index,$event.target)">Modifica</b-btn>
                            <b-btn style="margin:0px 0px 1px 2px;" size="sm" @click.stop="risultati(row.item,row.index,$event.target)">Risultati</b-btn>
                        </template>

            </b-table>

            <div class="row my-1">
                <div class="col-md-8 col-sm-12">
                    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
                </div>
                <div class="col-md-4 col-sm-12 text-right">
                    <b-form-fieldset horizontal label="Righe per pagina" :label-cols="6">
                        <b-form-select :options="pageOptions" v-model="perPage" />
                    </b-form-fieldset>
                </div>
            </div>
        </div>

        <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>

    </b-card>

    <!-- Modal Component -->
    <b-modal v-model="deleteModal.show" title="Elimina">
        <p class="my-2">Confermi l'eliminazione dell'opzione del sondaggio #{{deleteModal.id}}?</p>
        <div slot="modal-footer" class="w-100">
            <b-btn size="sm" class="float-right" variant="primary" @click="delItem()" style="margin: 2px;">
                Conferma
            </b-btn>
            <b-btn size="sm" class="float-right" variant="secondary" @click="deleteModal.show=false" style="margin: 2px;">
                Annulla
            </b-btn>
        </div>
    </b-modal>
    
</div>
</template>

<script>
import moment from 'moment'

import {
    NAMESPACE
} from '../config.js'

import {
    ctrlVismenu
} from '../util.js'

import {
    Categoria
} from '../classes.js'

export default {
    name: 'apptable',
    data: function () {
        return {   
            id: this.$route.params.id,
            tipo: this.$route.params.tipo, 
            domandasondaggioscheda: "",      
            items: [],
            namespace: NAMESPACE,
            fields: {
                id: {
                    label: '#',
                    sortable: true
                },
                risposta: {
                    label: 'Opzione',
                    sortable: true
                },  
                percentualesondaggiorisposte: {
                    label: 'Percentuale risposte',
                    sortable: true
                },
                numerosondaggiorisposteVis: {
                    label: 'Numero risposte',
                    sortable: true
                },        
                modifica: {
                    label: ' ',
                    'class': 'text-right'
                }
            },
            deleteModal: {
                id: null,
                show: false
            },
            currentPage: 1,
            perPage: 10,
            pageOptions: [{
                text: 10,
                value: 10
            }, {
                text: 25,
                value: 25
            }, {
                text: 50,
                value: 50
            }],
            sortBy: null,
            sortDesc: false,
            filter: null,
            totalRowsFilter: null,
            modalDetails: {
                index: '',
                data: ''
            },
            error: '',
            showerror: false,
            showtable: false
        };
    },
    computed: {
        totalRows: {
            // getter
            get: function () {
                return this.totalRowsFilter || this.items.length || 0;
            },
            // setter
            set: function (newValue) {
                this.totalRowsFilter = newValue;
            }
        }
    },
    methods: {
        insert() {
            this.$router.push(`/app/dettagliosondaggioopzione/id_scheda/${this.id}/tipo/${this.tipo}`);            
        },
        details(item, index, button) {
            this.$router.push({
                path: `/app/dettagliosondaggioopzione/id/${item.id}/id_scheda/${this.id}/tipo/${this.tipo}`
            });
        },
        risultatitot(item, index, button) {
            this.$router.push({
                path: `/app/sondaggiorisposte/id_scheda/${this.id}/tipo/${this.tipo}`
            });
        },
        risultati(item, index, button) {
            this.$router.push({
                path: `/app/sondaggiorisposte/id_scheda/${this.id}/tipo/${this.tipo}/id_sondaggioopzione/${item.id}`
            });
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        del(item, index, button) {
            this.deleteModal.id = item.id;
            this.deleteModal.show = true;
        },
        loadData() {

            var token = localStorage.getItem('token');
            this.axios.get(NAMESPACE + 'rest/sondaggioopzioni/id_scheda/' + this.id + '/tipo/' + this.tipo, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            this.items = response.data.message;

                            let apptable = this;

                            this.items.forEach(function(element, index) {                    
                                element.numerosondaggiorisposteVis = element.numerosondaggiorisposte + "/" + element.numerototalesondaggiorisposte
                            
                            });

                            this.showtable = true;

                        } else {
                            throw new Error(response.data.message);
                        }

                    } catch (e) {
                        this.showerror = true;
                        this.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    this.showerror = true;
                    this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

        },
        delItem() {

                var apptable = this;

                var token = localStorage.getItem('token');
                this.axios.delete(NAMESPACE + 'rest/sondaggioopzione/' + this.deleteModal.id, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                //forse può essere fatta diversamente e meglio
                                for (var i = 0; i < apptable.items.length; i++) {
                                    if (this.items[i].id == this.deleteModal.id) {
                                        this.items.splice(i, 1); //delete
                                        break;
                                    }
                                }
                                this.deleteModal.show = false;


                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {

                            this.deleteModal.show = false;
                            apptable.showerror = true;
                            apptable.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {

                        this.deleteModal.show = false;
                        apptable.showerror = true;
                        apptable.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });

            },
            getDescTipo(tipo) {
                var cat = new Categoria();
                return cat.getTipoByFlag(tipo);
            },

    },
    filters: {
        formatDate: function(value) {
            if (!value) return '';
            return moment(String(value)).format('DD/MM/YYYY')
        },
        formatNote: function(value) {
            var numChar = 150;
            if (!value) return '';
            return value.substr(0, numChar) + (value.length <= numChar ? '' : ' ...');
        }
    },
    created: function () {           
        
        if(!ctrlVismenu("E")){
            this.$router.replace('/accessdenied');
            return;
        }     

        if(this.tipo == 'E'){

            var token = localStorage.getItem('token'); 

            this.axios.get(NAMESPACE + 'rest/eventi/' + this.id, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            var res = response.data.message;
                            if (res.length > 0) {
                                this.domandasondaggioscheda = res[0].domandasondaggio;

                                this.loadData();

                            } else {
                                throw new Error("Errore dati non trovati!");
                            }


                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        this.showerror = true;
                        this.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    this.showerror = true;
                    this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

        }

       

    }
}
</script>
